module.exports = __webpack_public_path__ + "static/media/searchPlant.5ac2eb5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Classifier/searchPlant.svg
// module id = 833
// module chunks = 0